import "./reviews.scss";
import { Rating } from "@mui/material";
import dateformat from "dateformat";

// icon
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";

const ReviewsNew = ({ item }) => {
  return (
    <div className="customer-reviews">
      <div className="customer-reviews-details">
        <div className="customer-name">
          <h4>
            {item.user
              ? `${item.user.firstName} ${item.user.lastName || ""}`
              : item.username}
          </h4>
          <p>
            {item.created_at
              ? dateformat(new Date(item.created_at), "dd mmm yyyy")
              : ""}
          </p>
        </div>
        <div className="rating">
          <Rating
            name="read-only"
            value={item.rating}
            readOnly
            sx={{ fontSize: "23px" }}
            icon={<StarRoundedIcon fontSize="inherit" />}
            emptyIcon={<StarRoundedIcon fontSize="inherit" />}
          />
        </div>
        <div className="verified-purchase">
          <VerifiedRoundedIcon className="icon" /> <p>Verified purchase</p>
        </div>
        <div className="review-description">
          <p>{item.review}</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewsNew;
